import styled from 'styled-components';

export const Label = styled.label`
  display: inline-flex;
  flex-direction: row;
  align-items: center;
  cursor: pointer;
  transition: opacity 200ms;

  &:hover {
    opacity: 0.6;
  }

  span {
    margin-left: 0.8rem;
    font-size: 1.2rem;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
`;
